module.exports = __webpack_public_path__ + "static/media/emblem.f6b1fb3e.svg";